import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";

const Landing = lazy(() => import("@/pages/Landing"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const Insights = lazy(() => import("@/pages/Insights"));
const Marketplace = lazy(() => import("@/pages/Marketplace"));
const SectorPage = lazy(() => import("@/pages/SectorPage"));

const Fallback = () => <div className="min-h-screen bg-[#090909]" aria-hidden="true" />;

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      <BrowserRouter>
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/marketplace/:la" element={<Marketplace />} />
            <Route path="/marketplace/:la/:sector" element={<SectorPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
